<template>
<div class="background-03">

  <v-layout row wrap>
    <v-flex xs12 sm2 md2 class="hidden-xs-only ">
      <image-app class="animated fadeInLeft" :imaSize="300" imaSrc="design/banco1-1-3" imaAlt=""></image-app>
    </v-flex>
    <v-flex xs12 sm9 class="animated fadeInUp dura_1">
      <ui-title-one titleAccess="Analice su presupuesto " titleLevel="h1">
        <template slot="partOne"> Analice su <br></template>
        <!-- <template slot="partTwo"></template> -->
        <template slot="partThree"> presupuesto </template>
      </ui-title-one>
    </v-flex>
  </v-layout>

  <v-layout row wrap>
    <v-flex xs12 class="text-xs-center">
      <ui-simple-lsc  :vidTittle="'Analice su presupuesto'" videoEmbed="ADMINISTRACIONDINERO39AnalizePresupuesto.mp4"></ui-simple-lsc>
    </v-flex>
    <v-flex xs12 md6 class="animated fadeInUp dura_2 aligner">
      <p class="text-box adorn-bottom">Busque aquellas áreas con grandes diferencias y piense <strong>cómo disminuir los gastos</strong> en dichas categorías o incrementar sus ingresos. <br><br> Es probable que no pueda cambiar algunos gastos, pero otros como entretenimiento o ropa,
        pueden ofrecerle mayor flexibilidad a la hora de <strong>limitar sus gastos</strong>.
      </p>
    </v-flex>
    <v-flex xs12 sm5 md6 mb-5 text-xs-center class="aligner animated fadeIn dura_2">
      <image-app class="animated fadeInLeft" :imaSize="480" imaSrc="contenido/diapositiva_40" imaAlt="Calculadora, bolígrafo y presupuesto"></image-app>
    </v-flex>
  </v-layout>

</div>
</template>

<script>
export default {
  props: {
    modName: {
      type: String,
      required: false
    }
  },
  data() {
    return {};
  },
  mounted() {
    this.$store.commit("nextShow", true);
  }
};
</script>



// WEBPACK FOOTER //
// davivienda-39.vue?5ce0770c